import React from "react"
import Constants from "../../utils/constants"
import { Container, Typography } from '@material-ui/core';


const Error = (props) => {
  const { LANGUAGES } = Constants
  const { ErrRouteMsg } = LANGUAGES
  const language = window.navigator.language.slice(0, 2)

  return (
    <Container maxWidth="xs" className="container">
      <div style={{ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
        <Typography variant="h5">
          {ErrRouteMsg[language]}
        </Typography>
      </div>
    </Container>
  )
}

export default Error